import { Routes } from '@angular/router';
import { AuthGuard } from './core/AuthGuard/authguard';
import { AcessoNegadoComponent } from './layouts/access/acesso-negado.component';
import { ContainerComponent } from './layouts/container/container.component';
import { NegateAccessGuard } from './core/AuthGuard/negate-authguard';


export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard], // Protege com AuthGuard
    component: ContainerComponent, // Usando layout completo
    children: [      
      {path: '',  loadChildren: () => import('./components/components.routes').then(r => r.routes), canActivate: [AuthGuard]},              
    ]
  },
  {
    path: 'acesso-negado',
    component: AcessoNegadoComponent, // Carrega diretamente o Acesso Negado    
    title: 'Acesso Negado',
    canActivate: [NegateAccessGuard], // Adiciona o guard aqui
  },
  { 
    path: '**', 
    redirectTo: '' // Redireciona rota não encontrada para o dashboard
  }
];
export default routes;

